globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.FaqQuestionsController = (function(superClass) {
  utils.extend(FaqQuestionsController, superClass);

  FaqQuestionsController.thumbnailClass = '.faq-item-thumbnail';

  function FaqQuestionsController() {
    return FaqQuestionsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(FaqQuestionsController.prototype, {
    init: function(){
      this.$html = $('html');

      this.initQuestions();
      this.initCKEditor();

      return FaqQuestionsController.__super__.init.apply(this, arguments);
    },
    initQuestions: function(){
      var $body = $('body');
      var controller = this;

      $body.on('click', '.btn-update-question', function() {
        var $updateQuestionBtn = $(this);
        var $faqItemThumbnail  = $updateQuestionBtn.closest(FaqQuestionsController.thumbnailClass);

        $faqItemThumbnail.find('.question, .answer, .question-btn').hide();
        $faqItemThumbnail.find('.question-update-form').show().find('.question-text-textarea').focus();
      });

      $body.on('click', '.btn-return-container', function() {
        var $returnBtn        = $(this);
        var $faqItemThumbnail = $returnBtn.closest(FaqQuestionsController.thumbnailClass);
        var $form             = $faqItemThumbnail.find('.question-update-form');

        $form.hide();
        $faqItemThumbnail.find('.question, .answer, .question-btn').show();
      })

      $body.on('submit', '.question-update-form form', function(e) {
        var $form             = $(this);
        var $faqItemThumbnail = $form.closest(FaqQuestionsController.thumbnailClass);

        appCustomerSpace.Loader().start({ $container: $form })

        var success_callback = function(data) {
            if(data.response) {
                var $newFaqItemThumbnail = $(data.views.partial);
                $faqItemThumbnail.replaceWith($newFaqItemThumbnail);
                appCustomerSpace.LimitlessPlugins.initPlugins();
                appCustomerSpace.Loader().stop();
                controller.initCKEditor();
            }
        }

        $.post(
            $form.attr('action'),
            $form.serialize(),
            success_callback
        );

        return false;
      });

      $body.on('submit', '.question-delete-form form', function(e) {
        var $form             = $(this);
        var $faqItemThumbnail = $form.closest(FaqQuestionsController.thumbnailClass);
        var modalOptions      = {
          message: "Voulez-vous vraiment supprimer cette question/réponse ?",
          buttons: {
            confirm: {
              label: "Confirmer",
              className: "btn btn-primary float-right mr-10",
            },
            cancel: {
              label: "Annuler",
              className: "btn btn-default float-right",
            }
          },
          callback: function(result) {
            if(result) {
              var success_callback = function(data) {
                if(data.response) {
                  if (data.questions_count > 0) {
                    appCustomerSpace.Loader().start({ $container: $faqItemThumbnail })

                    appCustomerSpace.Loader().stop({ $container: $faqItemThumbnail }, function(){
                      $faqItemThumbnail.fadeOut('fast').remove();
                    });
                  } else {
                    location.reload();
                  }
                  controller.initCKEditor();
                }
              }
              $.post(
                  $form.attr('action'),
                  $form.serialize(),
                  success_callback
              );
            }
            this.hide();
          }
        };

        e.preventDefault();
        bootbox.confirm(modalOptions);

        return false;
      });
    },
    initCKEditor: function() {
      var $textarea = this.$html.find('textarea');

      $textarea.each(function() {
          var $currentTextarea = $(this);
          var textareaId = $currentTextarea.attr('id');
          var existingEditor = CKEDITOR.instances[textareaId];

          if (existingEditor) {
            existingEditor.destroy();
          }

          if($currentTextarea.hasClass('answer-text-textarea')){
            var maxCharCount = 1100;
          } else {
            var maxCharCount = 250;
          }

          CKEDITOR.replace(textareaId, {
            customConfig: globalThis.ckeditor_assets.configFaq,
            wordcount: {
              showParagraphs: false,
              showWordCount: false,
              showCharCount: true,
              countSpacesAsChars: true,
              maxCharCount: maxCharCount
            }
          });
      });
    }
  });

  return FaqQuestionsController;

})(appCustomerSpace.Controllers.Websites.MainController);
